<div class="content-wrapper-inner relative">
  <app-disabled-section-widget [service]="'voice'" (changeState)="testingDisabled = !$event.service"></app-disabled-section-widget>
  <div *ngIf="testingDisabled === false">
    <div class="create-test-section border">
      <app-vt-form (onAfterSave)="afterSaveTestCase()" [pauseUpdate]="pauseUpdateForm"></app-vt-form>
    </div>
    <app-vt-search-form (onSubmit)="onSubmitFilter($event)"></app-vt-search-form>
    <div class="dataTables_wrapper form-inline dt-bootstrap pos-relative">
      <app-vt-results-table (changeBatch)="selectedRows.set($event)"></app-vt-results-table>
      <div class="table-action-info-bar" *ngIf="selectedRows().length">
        <div class="info-left">
          <div class="text-icon-holder" tabindex="0" (keyup.enter)="batchClear()" (click)="batchClear()">
            <span class="icon">
              <span class="selected icon-done"></span>
            </span>
            <span class="text">{{ selectedRows().length }} Selected</span>
          </div>
        </div>
        <div class="info-right">
          <button [disabled]="!hasReimbursableTests()" class="btn ghost-btn btn-action text-icon-holder" (click)="onBatchReimburse()" *ngIf="isAdmin">
            <span class="icon">
              <span class="far fa-money-bill-alt fs-4"></span>
            </span>
            <span class="text ms-0_5">Reimburse</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #reimburseModalTpl let-dialogRef="dialogRef">
  <confirm-modal [dialogRef]="dialogRef"></confirm-modal>
</ng-template>
